// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-wrapper:not(.order-list-like) {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  padding: 16px;
  background-color: #ffffff;
  margin-bottom: 1% !important;
  gap: 0px !important;
  width: 85%;
  background-color: #f5f5f0 !important;
}
.card-wrapper-winners {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  padding: 10px !important;
  background-color: #ffffff;
  margin-bottom: 1% !important;
  gap: 0px !important;
  width: 85% !important;
  background-color: #f5f5f0 !important;
}
.title-color {
  color: #3366ff;
}
.card-direction {
  display: flex;
  flex-direction: initial;
}
.trophy-icon {
  font-size: 35px;
  color: #ffbf00;
  margin-top: 65%;
}
.small-icons {
  color: #1890ff;
}
.trophy-div {
  display: flex;
  align-content: center;
  justify-content: center;
  margin-right: 2%;
}
.card-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}
.date-order,
.balloonId-order {
  font-size: 14px;
  color: #888888;
}
.product-info-ballon {
  display: flex;
  align-items: center;
  flex-direction: row !important;
  margin-right: 3%;
  width: 100%;
}
.awarded-icons {
  font-size: 20px;
  color: #ffbf00;
  margin-right: 2%;
}
.unawarded-icons {
  font-size: 20px;
  color: #1890ff;
  margin-right: 2%;
}
.product-text-info {
  width: 100%;
}
.product-info-ballon img {
  width: 60px;
  height: 60px;
  margin-right: 12px;
  border-radius: 4px;
  border-right: 1px solid #e0e0e0;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
}
.product-info-header-ballon {
  display: flex;
  align-items: center;
}
.status-order-container {
  display: flex;
  align-items: center;
}
.dot-status {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 8px;
}
.order-details {
  display: flex;
  justify-content: flex-end;
}
.button-details {
  font-size: 14px;
  padding: 8px 16px;
  width: 60%;
}
@media (min-width: 769px) and (max-width: 930px) {
  span {
    font-size: 12px !important;
  }
}
@media screen and (max-width: 768px) {
  .button-details {
    width: 100% !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/PopBallon/CustomCard.less"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,kBAAA;EACA,0CAAA;EACA,aAAA;EACA,yBAAA;EACA,4BAAA;EACA,mBAAA;EACA,UAAA;EACA,oCAAA;AACJ;AAEA;EACI,yBAAA;EACA,kBAAA;EACA,0CAAA;EACA,wBAAA;EACA,yBAAA;EACA,4BAAA;EACA,mBAAA;EACA,qBAAA;EACA,oCAAA;AAAJ;AAGA;EACI,cAAA;AADJ;AAIA;EACI,aAAA;EACA,uBAAA;AAFJ;AAKA;EACI,eAAA;EACA,cAAA;EACA,eAAA;AAHJ;AAMA;EACI,cAAA;AAJJ;AAOA;EACI,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBAAA;AALJ;AAQA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AANJ;AASA;;EAEI,eAAA;EACA,cAAA;AAPJ;AAUA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,WAAA;AARJ;AAWA;EACI,eAAA;EACA,cAAA;EACA,gBAAA;AATJ;AAYA;EACI,eAAA;EACA,cAAA;EACA,gBAAA;AAVJ;AAaA;EACI,WAAA;AAXJ;AAcA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,+BAAA;EACA,0CAAA;AAZJ;AAeA;EACI,aAAA;EACA,mBAAA;AAbJ;AAgBA;EACI,aAAA;EACA,mBAAA;AAdJ;AAiBA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAfJ;AAkBA;EACI,aAAA;EACA,yBAAA;AAhBJ;AAmBA;EACI,eAAA;EACA,iBAAA;EACA,UAAA;AAjBJ;AAqBA;EACI;IACI,0BAAA;EAnBN;AACF;AAsBA;EACI;IACI,sBAAA;EApBN;AACF","sourcesContent":[".card-wrapper:not(.order-list-like) {\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);\n    padding: 16px;\n    background-color: #ffffff;\n    margin-bottom: 1% !important;\n    gap: 0px !important;\n    width: 85%;\n    background-color: #f5f5f0 !important;\n}\n\n.card-wrapper-winners {\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);\n    padding: 10px !important;\n    background-color: #ffffff;\n    margin-bottom: 1% !important;\n    gap: 0px !important;\n    width: 85% !important;\n    background-color: #f5f5f0 !important;\n}\n\n.title-color {\n    color: #3366ff;\n}\n\n.card-direction {\n    display: flex;\n    flex-direction: initial;\n}\n\n.trophy-icon {\n    font-size: 35px;\n    color: #ffbf00;\n    margin-top: 65%\n}\n\n.small-icons {\n    color: #1890ff;\n}\n\n.trophy-div {\n    display: flex;\n    align-content: center;\n    justify-content: center;\n    margin-right: 2%;\n}\n\n.card-header {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 12px;\n}\n\n.date-order,\n.balloonId-order {\n    font-size: 14px;\n    color: #888888;\n}\n\n.product-info-ballon {\n    display: flex;\n    align-items: center;\n    flex-direction: row !important;\n    margin-right: 3%;\n    width: 100%;\n}\n\n.awarded-icons {\n    font-size: 20px;\n    color: #ffbf00;\n    margin-right: 2%;\n}\n\n.unawarded-icons {\n    font-size: 20px;\n    color: #1890ff;\n    margin-right: 2%;\n}\n\n.product-text-info {\n    width: 100%;\n}\n\n.product-info-ballon img {\n    width: 60px;\n    height: 60px;\n    margin-right: 12px;\n    border-radius: 4px;\n    border-right: 1px solid #e0e0e0;\n    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.product-info-header-ballon {\n    display: flex;\n    align-items: center;\n}\n\n.status-order-container {\n    display: flex;\n    align-items: center;\n}\n\n.dot-status {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    margin-right: 8px;\n}\n\n.order-details {\n    display: flex;\n    justify-content: flex-end;\n}\n\n.button-details {\n    font-size: 14px;\n    padding: 8px 16px;\n    width: 60%;\n\n}\n\n@media (min-width: 769px) and (max-width: 930px) {\n    span {\n        font-size: 12px !important;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .button-details {\n        width: 100% !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
